//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

   import { mapState } from 'vuex'
   export default {
       props: ['resource'],
       methods: {
           close: function() {
               if (event.srcElement.className == 'modal-container' || event.srcElement.className == 'close_container' || event.srcElement.className == 'close' || event.srcElement.tagName == 'path') {
                this.$store.commit('modalStore/setModal', false)
            }
        },
    }
}
